import { axiosClient } from "utilz";

export const getCustomerContractSettings = async (customerId: string) => {
  try {
    const url = `/fetch/customer/settings/contract/${customerId}`;

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      console.log(resData);
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
